//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'

import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'home',
 data(){
    return {
      selType: 1,//查询数据类型 1查询案例  2查询企业
      oneProdTypeList: null,//产品行业分类
      twoProdTypeList: null,//产品行业分类
      threeProdTypeList: null,//产品行业分类
      
      companyTypeList: [
          {companyTypeName:"标识"},
          {companyTypeName:"广告"},
          {companyTypeName:"展示道具 "},
          {companyTypeName:"五金制品"},
          {companyTypeName:"安装维修"},
          {companyTypeName:"原材料"},
      ],//企业的行业类型
      List:[
          {name:"全国"},
          {name:"北京"},
          {name:"上海"},
          {name:"广州"},
          {name:"杭州"},
      ],//城市列表
      searchStr: this.$route.query.searchStr,//输入框  搜索条件
      searchStrCompany: this.$route.query.searchStrCompany,
      pageSizeSel: 10,//分页条数

      checkOneProdType: "-1",//选中的产品案例行业分类id
      checkTwoProdType: "-1",//选中的产品案例2级分类id
      checkThreeProdType: "-1",//选中的产品案例3级分类id

      xmpcCpalSelObj: null,
      loadProdCaseName: "加载更多",//产品方案底部加载更多按钮名称
      canSelProdCase: true,//是否还能点击加载更多产品方案  true可以，false已经全显示完了
      releaseProdCaseList: [],//当前显示的产品方案list

      checkCompanyType: "-1",//选中的企业行业类型id
      companySelObj: null,
      loadCompanyName: "查看更多企业",//企业信息底部加载更多按钮名称
      canSelCompany: true,//是否还能点击加载更多企业信息  true可以，false已经全显示完了
      companyInfoList: [],//当前显示的企业信息list
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    }
  },
 components:{
    Header,
    Footer
 },

  methods:{
   
  },
  mounted(){
    document.title = "协会列表"
        $$(document).scroll(function(){
      var y = $$(document).scrollTop()
      console.log()
      if(y >= 100){
          $(".newindextop").addClass("newindextop1").css({"top":0})
      }else{
         $(".newindextop").removeClass("newindextop1").css({"top":0})
      }
    })
  },
  created(){
    let that = this;
    that.xmpcCpalSelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
    that.companySelObj = {"page":{"pageNum":0,"pageSize": that.pageSizeSel},"searchStr": that.searchStr};
     
    this.$store.commit('home/setMenuStyle', 1);//为了显示灰色头部背景   2025数字云平台位置
    this.$store.commit('home/setMenuActive', 1);
    that.selType = (that.$route.query.selType != null && this.$route.query.selType != "" ) ? this.$route.query.selType : 1;
    if(that.selType == 2){
      that.$store.commit('home/setMenuActive', 1);////
    }
    // that.$store.commit('home/setSelInputType', 1);////0显示跳转页面的搜索框   1显示当前页面搜索的搜索框
    // if(that.societyId != null && that.societyId != '' && that.societyId != undefined){
    //   that.$store.commit('home/setSocietyLogoUrl', window.localStorage.getItem('logoImgUrl'));
    // }
    that.fnInitDataOne();
    
    
  },
  updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    //每个16:7.52的图片(企业封面)加载完重新算高度
    $$(".autoCompanyImgHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*7.52/16);
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/list.vue